type WolfMarkProps = {
  className?: string
  title?: string
}

export function WolfMark({ className, title = 'Wolf Forge' }: WolfMarkProps) {
  return (
    <img
      alt={title}
      aria-label={title}
      className={className}
      src="/wolf-forge-logo.png"
      role="img"
      style={{
        aspectRatio: '1 / 1',
        objectFit: 'cover',
        objectPosition: 'center',
        display: 'block'
      }}
    />
  )
}
